import React from "react";
import { withRouter } from "../../../App";
import { connect } from "react-redux";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { dateFormat } from "../../../utils/date";
import { getCompanies } from "../../../store/selectors/Companies/CompaniesList";

const GridTab = ({ companies }) => {
  return (
    <>
      <div className="row">
        {companies?.map((item, index) => (
          <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
            <div className="card">
              <div className="card-body">
                <div className="card-use-box">
                  <div className="card__text">
                    <h4 className="mb-0">
                      {item?.companyName}
                    </h4>
                    <p>{item?.email}</p>
                  </div>
                  <ul className="post-pos">
                    
                    <li>
                      <span className="card__info__stats">
                      Registration Date:{" "}
                      </span>
                      <span>{dateFormat(item?.regDate)}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    companies: getCompanies(state),
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(GridTab));
